import React from 'react';
import { useQuery } from "@tanstack/react-query";
import { Row, Col, Card } from 'react-bootstrap';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import '../orders/Statistic.css';
import Layout from '../Layout';
import { useNavigate } from 'react-router';
import { StatContainer } from './ProductComponent';
import { ProductApi } from '../../app/api/product.api';

export function ProductStatistic() 
{

  const navigate = useNavigate();

  const product = ProductApi(); 
  
  const fetchData = async () => { 
    const {data} = await product.getBestSeller();
    return data; 
  }
  const { isLoading, data=[], error } = useQuery({  queryKey: ["chart1"], queryFn: fetchData });


  return (

    <Layout activeMenu={2}>
    
      <div className='container-fluid'>
        <div className="row justify-content-center mb-5 mt-4">
          <div className="col-md-11">  

            {/* Fil d'Ariane / Titre */}
            <div className="row bg-white border py-4 text-center my-4">
              <h1 className="fw-bold display-6 text-muted"> Dashboard produit </h1>
              <nav className="breadcrumb-nav">
                <span className="text-muted"> Statistique </span>
              </nav>
            </div>

            {/* Barre de Filtres et Contrôles */}
            <div className="row mb-4 g-4 mt-2">
              <div className="d-flex  gap-3 flex-column flex-md-row justify-content-between align-items-center border-bottom pb-3 mb-4">
                {/* Vue Grille/Liste */}
                <div className="d-flex align-items-center gap-3 display-controls">
                  <span className="text-secondary lead"><i className="bi bi-grid-3x3-gap-fill"></i></span>
                  <span className="text-muted lead"> La gestion des produits </span>
                </div>
                {/* Infos et Tris */}
                <div>
                  <button onClick={() => navigate(-1)} className='btn btn-sm btn-outline-dark px-3'> Retour <i className="bi bi-chevron-right ms-1"></i> </button>
                </div>
              </div>
            </div>

            {/* Cartes de Statistiques */}
            <StatContainer />

            {/* Graphe Mensuel */}
            <Row className="mb-2">
              <Col xs={12} className='px-0'>
                <Card className="chart-card border">
                { 
                  ( isLoading ) ? (
                    <Card.Body>
                      <div className="d-flex flex-column align-items-center gap-3 py-5">
                        <div className="spinner-border text-green mb-3" style={{ width: '6rem', height: '6rem' }}></div>
                        <p className="text-secondary"> Chargement en cours... </p>
                      </div>
                    </Card.Body>
                  ) : (
                    <Card.Body>
                      <span className="text-muted mb-4"> Les 12 produits les plus vendus </span>
                      <ResponsiveContainer width="100%" height={460}>
                        <BarChart data={data} margin={{ top: 40, right: 30, left: 0, bottom: 20 }}  >
                          <CartesianGrid strokeDasharray="3 3" stroke="#e9ecef" />
                          <XAxis dataKey="produit" tick={{ fill: '#6c757d', fontSize: 12 }} angle={-45} textAnchor="end" interval={0}  />
                          <YAxis tick={{ fill: '#6c757d', fontSize: 12 }} />
                          <Tooltip
                           contentStyle={{
                              backgroundColor: '#fff',
                              border: '1px solid #dee2e6',
                              borderRadius: '4px',
                            }}
                          />
                          <Legend wrapperStyle={{ paddingTop: '20px' }} iconType="square" />
                          <Bar dataKey="quantite" fill="#307072" radius={[8, 8, 0, 0]} name="Quantité" />
                        </BarChart>
                      </ResponsiveContainer>
                    </Card.Body>
                  )
                  }
                  {
                    (error) && (
                      <Card.Body>
                        <div className="text-center p-4 border alert alert-danger w-100">
                          Une erreur est survenue. Vueiller vérifier votre connexion 
                        </div>
                      </Card.Body>
                    )
                  }
                </Card>
              </Col>
            </Row>
          
          </div>
        </div>
      </div>

    </Layout>
  );
};


